enum CandidatePageContents {
  All = 'All',
  Childcare = 'Childcare',
  Elderlycare = 'Elderly Care',
  ChildcareElderlycare = 'Childcare + Elderly Care'
}

export default CandidatePageContents;
